import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  leftContainer: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    fontSize: "23px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "28px",
    letterSpacing: "normal",
    color: "#00003D",
    marginLeft: "25px",
    marginRight: "25px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      marginBottom: "10px",
      flexWrap: "wrap",
    },
  },
  button: {
    lineHeight: "20px",
    color: "#F04031",
    size: "17px",
    fontWeight: 550,
    margin: "0 10px",
  },
  sortChildren: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginRight: theme.spacing(1),
  },
  leftTitle: {
    // fontSize: "1.625rem",
    // fontFamily: "Oswald sans-serif",
    // fontWeight: 800,
    // lineHeight: "1",
    textAlign: "left",
    font: "normal normal normal 23px/28px Helvetica",
    letterSpacing: "0px",
    color: "#00003D",
    opacity: 1,
    display: "flex",
    flexGrow: 1,
  },
}))

export default styles
